/**
 * Une adresse email ne dépend pas de la casse : on la saisit en minuscules.
 *
 * Un seul écouteur pour toute l'application, plutôt qu'un réglage par champ :
 * tout `<input type="email">`, et tout champ marqué `data-email` (liste
 * d'adresses dans une zone de texte), passe en minuscules pendant la frappe.
 * Un futur formulaire en profite sans rien faire. Le serveur l'impose de toute
 * façon (déclencheur en base, migration `zzzzzzzzzzzz_emails_en_minuscules.sql`) ;
 * ici, c'est pour que la personne voie ce qui sera enregistré.
 *
 * Posé en phase de capture sur `document`, il passe avant React, qui lit donc
 * déjà la valeur en minuscules dans son `onChange`.
 */
export function installEmailLowercase(): () => void {
  const handler = (event: Event) => {
    const el = event.target;
    if (!(el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement)) return;
    const estEmail = (el instanceof HTMLInputElement && el.type === 'email') || el.dataset.email !== undefined;
    if (!estEmail) return;
    const valeur = el.value;
    const minuscules = valeur.toLowerCase();
    if (valeur === minuscules) return;
    // Un champ type="email" n'expose pas la position du curseur (null) :
    // le curseur n'est restauré que là où le navigateur la donne.
    let debut: number | null = null;
    let fin: number | null = null;
    try { debut = el.selectionStart; fin = el.selectionEnd; } catch { /* type="email" */ }
    el.value = minuscules;
    if (debut !== null) {
      try { el.setSelectionRange(debut, fin ?? debut); } catch { /* type="email" */ }
    }
  };
  document.addEventListener('input', handler, true);
  return () => document.removeEventListener('input', handler, true);
}
